import {
	Boolean,
	Calendar,
	Email,
	EventSchedule,
	Hashtag,
	Link,
	Money,
	Percentage,
	ProgressBar,
	RowInsert,
	StringText,
	Table,
	Tag,
	ThumbsUp,
	Time,
	UserAdmin,
} from "@carbon/icons-react";
import { type FC } from "react";

import { type ColumnType } from "../validation/parseColumnType";

/**
 * Icon representing the type of a column.
 */
export const ColumnTypeIcon: FC<{
	className?: string;
	size?: number;
	fieldType: ColumnType | undefined;
}> = ({ className, size = 16, fieldType }) => {
	const props = { size, className };
	switch (fieldType) {
		case "Text":
			return <StringText {...props} />;
		case "Tag":
			return <Tag {...props} />;
		case "Date":
			return <Calendar {...props} />;
		case "Time":
			return <Time {...props} />;
		case "Date time":
			return <EventSchedule {...props} />;
		case "Time distance to now":
			return <EventSchedule {...props} />;
		case "Boolean":
			return <Boolean {...props} />;
		case "Email":
			return <Email {...props} />;
		case "URL":
			return <Link {...props} />;
		case "Number":
			return <Hashtag {...props} />;
		case "Currency":
			return <Money {...props} />;
		case "Percent":
			return <Percentage {...props} />;
		case "Link to record":
			return <RowInsert {...props} />;
		case "Reaction":
			return <ThumbsUp {...props} />;
		case "Table":
			return <Table {...props} />;
		case "Person":
			return <UserAdmin {...props} />;
		case "Progress bar":
			return <ProgressBar {...props} />;
		default:
			return <StringText {...props} />;
	}
};
